import { Data2, dateToString, newId } from '../../../features/data-types'
import { useSystemStateHooks } from '../../system'
import { AdjustmentNoteType, AdjustmentNote, AdjustmentNoteItem, AdjustmentNoteKind } from '../state/types'
import { Currency, TableName } from '../../../tables/types/types'
import { FiscalDocumentStatus } from '../../fiscal-documents'
import { O } from '../../../features/ui'

export const useAdjustmentNoteBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildAdjustmentNote = (data: Data2) => {
        const {
            id = newId(),
            code,
            type,
            table,
            operationId,
            items,
            amount,
            date,
            reason,
            kind,
            manual,
            fiscalStatus,
            fiscalDocumentId
        } = data

        const adjustmentNote: AdjustmentNote = {
            companyId: companyId!,
            id: id! as string,
            code: code! as number,
            type: type! as AdjustmentNoteType,
            table: table! as TableName,
            operationId: operationId! as string,
            items: (items || []) as AdjustmentNoteItem[],
            amount: amount! as number,
            currency: Currency.ARS,
            date: dateToString(date || new Date())!,
            reason: reason as O<string>,
            kind: kind as O<AdjustmentNoteKind>,
            manual: manual as O<boolean>,
            fiscalStatus: (fiscalStatus || FiscalDocumentStatus.PENDING) as FiscalDocumentStatus,
            fiscalDocumentId: fiscalDocumentId as O<string>
        }

        return adjustmentNote
    }

    return {
        buildAdjustmentNote
    }
}
